<div
  class="flex flex-row"
  [ngClass]="canClick && !fieldDef.meta?.value_hidden ? 'dotted-underline' : ''"
  (click)="clickField($event)"
>
  <div class="font-semibold mr-1 text-md" *ngIf="!excludeLabels">{{ fieldDef.label }}:</div>
  @if (fieldDef.meta?.value_hidden) {
    <div class="text-md">{{ value }}</div>
  } @else {
    <div class="text-md" [ngClass]="{ underline: customObjType !== 'User' }" (click)="value && goToBaseRecord()">
      {{ value | readableField: value : fieldDef : value }}
    </div>
  }
</div>
